import React, { useState, useEffect } from 'react'
import './ConfigReview.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import Editor from 'react-simple-code-editor'
import { highlight, languages } from 'prismjs'
import { useDispatch } from 'react-redux'
import { getConfigFile } from '../../../redux/slices'
import { AppDispatch } from '../../../services/lib'
import { ConfigFileResponse } from '../../../types/configs/configs'

interface ConfigReviewProps {
  configId: string
  script: string
}

const _urlToFile = async (url: string, mimeType: string): Promise<File> => {
  const response = await fetch(url)
  const buffer = await response.arrayBuffer()
  return new File([buffer], 'Config', { type: mimeType })
}

const ConfigReview: React.FC<ConfigReviewProps> = ({ configId, script }) => {
  const dispatch: AppDispatch = useDispatch()
  const [data, setData] = useState<string>('')
  const [file, setFile] = useState<string>('')

  useEffect(() => {
    _urlToFile(`data:application/json;base64,${file}`, 'application/json').then(
      dataFromFile => {
        const read = new FileReader()
        read.readAsBinaryString(dataFromFile)
        read.onloadend = function () {
          setData(read.result as string)
        }
      }
    )
  }, [file])

  useEffect(() => {
    const init = async () => {
      const configFileRes = await dispatch(
        getConfigFile({
          scriptId: script,
          configId
        })
      )
      if (getConfigFile.fulfilled.match(configFileRes)) {
        setFile((configFileRes.payload as ConfigFileResponse).file)
      }
    }

    init()
  }, [configId, dispatch, script])
  return (
    <>
      <Editor
        value={data}
        onValueChange={() => null}
        highlight={(data: string) => highlight(data, languages.js, 'js')}
        padding={10}
        style={{
          overflow: 'scroll',
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: 15,
          backgroundColor: '#FFFFFF',
          height: 900,
        }}
      />
    </>
  )
}
export default ConfigReview
